import React, { useState, useEffect, useRef } from 'react';
import { Card } from 'react-bootstrap';
import * as Constants from '../../constants/constants'
import { MDBIcon } from 'mdbreact';

const STATUSES = ["OPEN", "STARTED", "NEEDS PARTS", "FINISHED", "NEEDS APPROVAL"];
const STATUS_DOT = {
    "OPEN": "yellowdot_option",
    "STARTED": "greendot_option",
    "NEEDS PARTS": "reddot_option",
    "FINISHED": "bluedot_option",
    "NEEDS APPROVAL": "purpdot_option",
};

export default function JobCard(props) {
    const jobInfo = props.job;
    const [contextMenu, setContextMenu] = useState({ show: false, x: 0, y: 0 });
    const [activeSubmenu, setActiveSubmenu] = useState(null);
    const menuRef = useRef(null);

    useEffect(() => {
        if (!contextMenu.show) return;
        function handleClickOutside(e) {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setContextMenu(c => ({ ...c, show: false }));
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [contextMenu.show]);

    function handleRightClick(e) {
        if (!props.onQuickUpdate) return;
        e.preventDefault();
        setActiveSubmenu(null);
        setContextMenu({ show: true, x: e.clientX, y: e.clientY });
    }

    function quickUpdateStatus(status) {
        props.onQuickUpdate({ ...jobInfo, Status: status });
        setContextMenu(c => ({ ...c, show: false }));
    }

    function quickUpdateEmployee(name) {
        props.onQuickUpdate({ ...jobInfo, Employee: name });
        setContextMenu(c => ({ ...c, show: false }));
    }

    function MyItem() {
        let date = new Date(jobInfo.ScheduledDate)
        let today = new Date()
        date.setHours(0, 0, 0, 0)
        today.setHours(0, 0, 0, 0)
        if (date.getTime() === today.getTime()) {
            return (
                <p style={{
                    fontSize: "20px",
                    float: "right",
                    marginTop: "-10px",
                    marginRight: "-10px"
                }}>
                    {Constants.getTime(jobInfo.ScheduledDate)}
                </p>)
        }
        else {
            return (
                <>
                    <p style={{
                        fontSize: "20px",
                        float: "right",
                        marginTop: "-15px",
                        marginRight: "-10px"
                    }}>
                        {Constants.getDate(jobInfo.ScheduledDate)}<br/>
                        {Constants.getTime(jobInfo.ScheduledDate)}
                    </p>
                </>
            )
        }
    }

    return (
        <>
            <Card key={jobInfo._id} className={props.from === "invoice_screen" ? "jobcard_2" : "jobcard_jobs"} onClick={props.onClick} onContextMenu={handleRightClick} style={jobInfo.Waiting ? {boxShadow:"0 0 0 0.2rem rgb(38 143 255 / 50%)"} : {}} >
                <Card.Body style={{ display: "flex", flexDirection: "column" }}>
                    {jobInfo.Type === "APPOINTMENT" ?
                            <MyItem />
                        :
                        jobInfo.Status === "OPEN" ? <span className="yellowdot"></span> :
                            jobInfo.Status === "STARTED" ? <span className="greendot"></span> :
                                jobInfo.Status === "FINISHED" ? <span className="bluedot"></span> :
                                    jobInfo.Status === "NEEDS PARTS" ? <span className="reddot"></span> :
                                        jobInfo.Status === "NEEDS APPROVAL" ? <span className="purpdot"></span> :
                                            <span className="blackdot"></span>
                    }

                    <Card.Title>
                        {jobInfo.Lastname}, {jobInfo.Firstname}
                        <br />
                        {/* <i className="fas fa-phone-alt"></i>  */}  {jobInfo.Phone}
                        <br />
                        {/*  <i className="fas fa-car"></i> */}    {jobInfo.Vehicle}
                    </Card.Title>
                    <Card.Text style={{ whiteSpace: "pre-line" }}>
                        • {jobInfo.Description.replace(/\n/g, "\n• ")}
                    </Card.Text>
                    {jobInfo.Employee &&
                        <div className="assigned-employee">
                            <MDBIcon icon='user' />
                            <span style={{ paddingLeft: "5px" }}>{jobInfo.Employee.split(' ')[0]}</span>
                        </div>
                    }
                </Card.Body>
            </Card>

            {contextMenu.show && (
                <div ref={menuRef} className="context-menu" style={{ top: contextMenu.y, left: contextMenu.x }}>
                    <div
                        className="context-menu-item"
                        style={{ position: 'relative', justifyContent: 'space-between' }}
                        onMouseEnter={() => setActiveSubmenu('status')}
                    >
                        Edit Status <span>&rsaquo;</span>
                        {activeSubmenu === 'status' && (
                            <div className="context-menu" style={{ position: 'absolute', top: -5, left: '100%', marginLeft: 4 }}>
                                {STATUSES.filter(s => s !== jobInfo.Status).map(status => (
                                    <div key={status} className="context-menu-item" onMouseDown={() => quickUpdateStatus(status)}>
                                        <span className={STATUS_DOT[status]}></span>
                                        {status}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    {props.employeeList?.length > 0 &&
                        <div
                            className="context-menu-item"
                            style={{ position: 'relative', justifyContent: 'space-between' }}
                            onMouseEnter={() => setActiveSubmenu('employee')}
                        >
                            Edit Employee <span>&rsaquo;</span>
                            {activeSubmenu === 'employee' && (
                                <div className="context-menu" style={{ position: 'absolute', top: -5, left: '100%', marginLeft: 4 }}>
                                    {jobInfo.Employee &&
                                        <div className="context-menu-item context-menu-item--muted" onMouseDown={() => quickUpdateEmployee('')}>
                                            <MDBIcon icon='times' /> Unassign
                                        </div>
                                    }
                                    {props.employeeList.map(emp => (
                                        <div
                                            key={emp.EmployeeID}
                                            className={`context-menu-item${jobInfo.Employee === emp.EmployeeName ? ' context-menu-item--active' : ''}`}
                                            onMouseDown={() => quickUpdateEmployee(emp.EmployeeName)}
                                        >
                                            <MDBIcon icon='user' /> {emp.EmployeeName}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    }
                </div>
            )}
        </>
    )
}
